var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{style:(_vm.getStyle()),attrs:{"size":_vm.size,"color":_vm.avatar ? 'transparent' : 'primary'},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.avatar && !_vm.error)?_c('img',{attrs:{"alt":"Avatar","src":_vm.getImage()},on:{"error":_vm.imageError}}):_c('div',[_vm._v(_vm._s(_vm.getName()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }